export default "__VITE_PUBLIC_ASSET__d435afa9__"